
export default function factory() {
  return angular.element;
}
